/**
 * Renders a mobile browser frame with address bar in light mode.
 */
export function MobileFrameLight(props: { width: number; height: number; url?: string }) {
    const { width, height, url = '' } = props;
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 332 640"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Mobile Frame</title>
            <g filter="url(#filter0_d_378_3409)">
                <rect x="12" y="10" width="308" height="616" rx="32" fill="white" />
                <rect x="12.5" y="10.5" width="307" height="615" rx="31.5" stroke="#D3DCE4" />
            </g>
            <rect
                x="17"
                y="15"
                width="298"
                height="606"
                rx="27"
                stroke="#F5F7F9"
                stroke-width="8"
            />
            <path
                d="M95 11H241V25C241 36.0457 232.046 45 221 45H115C103.954 45 95 36.0457 95 25V11Z"
                fill="#F5F7F9"
            />
            <rect x="144" y="26" width="33" height="8" rx="4" fill="white" />
            <circle cx="189" cy="30" r="4" fill="white" />
            <rect x="36" y="66" width="260" height="24" rx="12" fill="#F5F7F9" />
            <text id="textUrl" x="70" y="83" fontFamily="Arial" font-size="12" fill="#333">
                {url}
            </text>
            <path
                d="M59 76.3333H58.5V75.381C58.5 74.7495 58.2366 74.1439 57.7678 73.6974C57.2989 73.2508 56.663 73 56 73C55.337 73 54.7011 73.2508 54.2322 73.6974C53.7634 74.1439 53.5 74.7495 53.5 75.381V76.3333H53C52.45 76.3333 52 76.7619 52 77.2857V82.0476C52 82.5714 52.45 83 53 83H59C59.55 83 60 82.5714 60 82.0476V77.2857C60 76.7619 59.55 76.3333 59 76.3333ZM56 80.619C55.45 80.619 55 80.1905 55 79.6667C55 79.1429 55.45 78.7143 56 78.7143C56.55 78.7143 57 79.1429 57 79.6667C57 80.1905 56.55 80.619 56 80.619ZM57.55 76.3333H54.45V75.381C54.45 74.5667 55.145 73.9048 56 73.9048C56.855 73.9048 57.55 74.5667 57.55 75.381V76.3333Z"
                fill="#3B454E"
            />
            <defs>
                <filter
                    id="filter0_d_378_3409"
                    x="0"
                    y="0"
                    width="332"
                    height="640"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="6" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_378_3409"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_378_3409"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}

/**
 * Renders a mobile browser frame with address bar in dark mode.
 */
export function MobileFrameDark(props: { width: number; height: number; url?: string }) {
    const { width, height, url = '' } = props;
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 332 640"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Mobile Frame</title>
            <g filter="url(#filter0_d_378_3409)">
                <rect x="12" y="10" width="308" height="616" rx="32" fill="#14171C" />
                <rect x="12.5" y="10.5" width="307" height="615" rx="31.5" stroke="#2D323A" />
            </g>
            <rect
                x="17"
                y="15"
                width="298"
                height="606"
                rx="27"
                stroke="#2D323A"
                stroke-width="8"
            />
            <path
                d="M95 11H241V25C241 36.0457 232.046 45 221 45H115C103.954 45 95 36.0457 95 25V11Z"
                fill="#2D323A"
            />
            <rect x="144" y="26" width="33" height="8" rx="4" fill="#14171C" />
            <circle cx="189" cy="30" r="4" fill="#14171C" />
            <rect x="36" y="66" width="260" height="24" rx="12" fill="#2D323A" />
            <text id="textUrl" x="70" y="83" fontFamily="Arial" font-size="12" fill="#DEDFE3">
                {url}
            </text>
            <path
                d="M59 76.3333H58.5V75.381C58.5 74.7495 58.2366 74.1439 57.7678 73.6974C57.2989 73.2508 56.663 73 56 73C55.337 73 54.7011 73.2508 54.2322 73.6974C53.7634 74.1439 53.5 74.7495 53.5 75.381V76.3333H53C52.45 76.3333 52 76.7619 52 77.2857V82.0476C52 82.5714 52.45 83 53 83H59C59.55 83 60 82.5714 60 82.0476V77.2857C60 76.7619 59.55 76.3333 59 76.3333ZM56 80.619C55.45 80.619 55 80.1905 55 79.6667C55 79.1429 55.45 78.7143 56 78.7143C56.55 78.7143 57 79.1429 57 79.6667C57 80.1905 56.55 80.619 56 80.619ZM57.55 76.3333H54.45V75.381C54.45 74.5667 55.145 73.9048 56 73.9048C56.855 73.9048 57.55 74.5667 57.55 75.381V76.3333Z"
                fill="#3B454E"
            />
            <defs>
                <filter
                    id="filter0_d_378_3409"
                    x="0"
                    y="0"
                    width="332"
                    height="640"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="6" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_378_3409"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_378_3409"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}
